const color = {
  primary: "#9FE870",
  secondary: "#0b5727",
} as const;

export default color;
